import {gql, useQuery} from "@apollo/client";
import {SiteType} from "graphql/types/SiteType";
import { useEffect } from "react";
import { useState } from "react";

export interface WarehouseOption {
    id: string;
    name: string;
}

const GET_WAREHOUSES = gql`
  query GetWarehouses {
    warehouses: getWarehouseListForHeadquarters {
      id
      name
      siteType
    }
  }
`;

interface WarehousesResponse {
    warehouses: {
        id: string;
        name: string;
        siteType: SiteType;
    }[];
}

export const useWarehouseOptions = (siteType: SiteType | 'ALL' = SiteType.WAREHOUSE) => {
    const [warehouseOptions, setWarehouseOptions] = useState<WarehouseOption[]>([]);
    const {data, loading, error} = useQuery<WarehousesResponse>(GET_WAREHOUSES);
    useEffect(() => {
        if (data) {
            setWarehouseOptions(data.warehouses.filter(w => siteType === 'ALL' || w.siteType === siteType).map(w => ({id: w.id, name: w.name})));
        }
    }, [data]);
    return {
        warehouseOptions,
        loading,
        error
    };
}; 